import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "forwardedAs", "refKey"];
import React, { forwardRef } from 'react';
import useMergedRefs from 'hooks/useMergedRefs';
import { useComboboxContext } from './Combobox';
var ComboboxInput = /*#__PURE__*/forwardRef(function (props, outerRef) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'input' : _props$as,
    forwardedAs = props.forwardedAs,
    _props$refKey = props.refKey,
    refKey = _props$refKey === void 0 ? 'ref' : _props$refKey,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useComboboxContext = useComboboxContext(),
    getInputProps = _useComboboxContext.getInputProps,
    setReferenceRef = _useComboboxContext.popover.setReferenceRef;

  // If there's a custom refKey, use that as the popover target
  // and pass the regular ref on as usual
  // Otherwise merge the refs and attach them to the default one
  var mergedRefs = useMergedRefs([setReferenceRef, outerRef]);
  var mergedCustomRefs = useMergedRefs([setReferenceRef, refKey in otherProps ? otherProps[refKey] : undefined]);
  var refs = {
    ref: refKey !== 'ref' ? outerRef : mergedRefs
  };
  if (refKey !== 'ref') {
    refs[refKey] = mergedCustomRefs;
  }
  if ('onChange' in otherProps || 'value' in otherProps) {
    // eslint-disable-next-line no-console
    console.warn('ComboboxInput: `onChange` or `value` props were found on a ComboboxInput instance. This can lead to unexpected behaviour, please use the the `inputValue` and `onInputChange` props on the parent `Combobox` component instead.');
  }
  return /*#__PURE__*/React.createElement(Component, _extends({}, getInputProps(otherProps), refs, {
    as: forwardedAs
  }));
});
ComboboxInput.displayName = 'ComboboxInput';
export default ComboboxInput;